module.exports = "/_next/static/images/3d8ea353e298e66d090f203d46a20886-fees-left-lg.jpg";